import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
//import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import QRCode from 'react-qr-code';
//import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { history } from '../../helpers/history';

//import { isMobile } from 'react-device-detect';


const useStyles = makeStyles(theme => ({
    logo: {
        [theme.breakpoints.up('xs')]: {
            width: '100%',
            height: '100%'
        },
        [theme.breakpoints.up('sm')]: {
            width: '100%',
            height: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '70%',
            height: '70%',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
            height: '70%',
        },
        [theme.breakpoints.up('xl')]: {
            width: '70%',
            height: '70%',
        },
    },
    logofooter: {
        [theme.breakpoints.up('xs')]: {
            width: '100%',
            height: '100%'
        },
        [theme.breakpoints.up('sm')]: {
            width: '25%',
            height: '25%'
        },
        [theme.breakpoints.up('md')]: {
            width: '25%',
            height: '25%'
        },
        [theme.breakpoints.up('lg')]: {
            width: '25%',
            height: '25%'
        },
        [theme.breakpoints.up('xl')]: {
            width: '25%',
            height: '25%'
        },
    },
    logoallwidth: {
        [theme.breakpoints.up('xs')]: {
            width: '100%',
            height: '100%'
        },
        [theme.breakpoints.up('sm')]: {
            width: '40%',
            height: '40%',
        },
        [theme.breakpoints.up('md')]: {
            width: '40%',
            height: '40%',
        },
        [theme.breakpoints.up('lg')]: {
            width: '40%',
            height: '40%',
        },
        [theme.breakpoints.up('xl')]: {
            width: '40%',
            height: '40%',
        },
    },
    logofooterallwidth: {
        [theme.breakpoints.up('xs')]: {
            width: '50%',
            height: '50%'
        },
        [theme.breakpoints.up('sm')]: {
            width: '15%',
            height: '15%'
        },
        [theme.breakpoints.up('md')]: {
            width: '15%',
            height: '15%'
        },
        [theme.breakpoints.up('lg')]: {
            width: '15%',
            height: '15%'
        },
        [theme.breakpoints.up('xl')]: {
            width: '15%',
            height: '15%'
        },
    },
    fondocabecera: {
        textAlign: "center",
    },
    fondodetalle: {

    },
    textocabecera: {
        [theme.breakpoints.up('xs')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            fontFamily: "RobotoCondensed-Bold",
        },
        [theme.breakpoints.up('sm')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            fontFamily: "RobotoCondensed-Bold",
        },
        [theme.breakpoints.up('md')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            fontFamily: "RobotoCondensed-Bold",
        },
        [theme.breakpoints.up('lg')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            fontFamily: "RobotoCondensed-Bold",
        },
        [theme.breakpoints.up('xl')]: {
            color: '#FFFEFF',
            fontSize: '140%',
            fontFamily: "RobotoCondensed-Bold",
        },

    },
    textocabeceradetalle: {
        color: '#000000',
        fontSize: '110%',
    },
    textocabeceradetalleinvisible: {
        color: '#EEEFF2',
        fontSize: '110%',
    },
    textovalor: {
        color: '#FFFEFF',
        fontSize: '450%',
        textAlign: "center",
    },
    textovalorreduce: {
        color: '#FFFEFF',
        fontSize: '300%',
        textAlign: "center",
    },
    textotitulodetalle: {
        color: '#000000',
        fontSize: '100%',
        fontFamily: "RobotoCondensed-Regular",
    },
    textotitulodetallenegrita: {
        color: '#000000',
        fontSize: '100%',
        fontFamily: "RobotoCondensed-Regular",
    },
    texttitleone: {
        color: '#B8992B',
        fontFamily: "RobotoCondensed-Bold",
        fontSize: '80%'
    },
    texttitletwo: {
        color: '#B8992B',
        fontFamily: "RobotoCondensed-Bold",
        fontSize: '80%'
    },
    line: {
        backgroundColor: '#4BA136',
        height: '1px',
        width: '100%'
    },
    fondotexto: {

    },
    submit: {
        [theme.breakpoints.up('xs')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderRadius: '0px',
            borderLeft: '3px solid #B8992B',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #B8992B',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #B8992B',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #B8992B',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('xl')]: {
            fontSize: '0.6rem',
            color: '#1a1919',
            borderLeft: '3px solid #B8992B',
            backgroundColor: "white",
            fontWeight: 'bold'
        },
    },
    gridMonto: {
        backgroundColor: "#B8992B"
    },
    gridTexto: {
        backgroundColor: "#EEEFF2"
    },

}));

const TranviaQR = props => {

    const classes = useStyles();

    const {
        amount,
        titleheader,
        title,
        databodyone,
        responseTranvia,
        titleone,
        titletwo,
        handleDownloadVoucher,
        handleDownloadDevice,
        handleResetPayment,
        typesizegrid,
        mac,
        tarifas,
        viewVoucher,
        ticketNumber,
        numberOfTickets,
        msg_informative
    } = props;
    //console.log('mac', mac)
    return (
        <div>


            <Grid container spacing={3} className={classes.fondocabecera} alignItems="center" direction="row" justifyContent="center">
                <Grid item xs={12} md={12}>
                    <img src={process.env.PUBLIC_URL + '/images/Logo-544x96.png'} alt="Logo" className={(typesizegrid === 6) ? classes.logo : classes.logoallwidth} />
                </Grid>
            </Grid>
            <br />
            <br />
            <Grid container spacing={3} className={classes.gridMonto} alignItems="center" direction="row" justifyContent="center">
                <Grid item xs={6} md={6} >
                    <br />
                    <Typography component="h1" variant="h1" className={classes.textocabecera} align="center">
                        {titleheader}
                    </Typography>
                    <br />
                </Grid>
                <Grid item xs={6} md={6}>
                    <br />
                    <Typography component="h1" variant="h1" className={classes.textocabecera} align="center">
                        $ {amount}
                    </Typography>
                    <br />
                </Grid>

            </Grid>
            <Grid container spacing={3} className={classes.gridTexto} alignItems="center" direction="row" justifyContent="center">
                <Grid item xs={6} md={6} className={classes.gridTexto}>
                    <Typography component="h1" variant="h1" className={classes.textocabeceradetalleinvisible} align="center">
                        {"Valor cancelado"}
                    </Typography>
                </Grid>

                <Grid item xs={6} md={6} className={classes.gridTexto}>
                    <Typography component="h1" variant="h1" className={classes.textocabeceradetalle} align="center">
                        {"Valor cancelado"}
                    </Typography>
                </Grid>

            </Grid>
            <br />
            <Grid container spacing={2} alignItems="center" direction="row" justifyContent="center">
                <Grid item xs={10} md={10} className={classes.fondotexto}>
                    <Typography component="h1" variant="h5" align="justify">
                        <b className={classes.texttitleone}>{title}</b>
                    </Typography>
                    <Typography component="h1" variant="h5" className={classes.textotitulodetalle} align="justify">
                        <b className={classes.textotitulodetallenegrita}>Ticket Nº {ticketNumber}</b>
                    </Typography>
                    {
                        <div style={{ height: "auto", margin: "0 auto", maxWidth: '100%', width: "100%" }}>
                            <QRCode
                                size={256}
                                style={{ height: "auto", maxWidth: "90%", width: "80%" }}
                                bgColor="#fff"
                                fgColor="#000"
                                value={responseTranvia.trama_qr}
                                viewBox={`0 0 256 256`}
                            />
                        </div>
                        /* <QRCode value={responseTranvia.trama_qr} size={isMobile ? '80%' : 384} bgColor="#fff" fgColor="#000" /> */
                    }
                    {/* <Typography component="h1" variant="h5" className={classes.textotitulodetalle} align="justify">
                        <b className={classes.texttitleone}>Generado por COOPERCO</b>
                    </Typography> */}
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center" direction="row" justifyContent="center">
                <Grid item xs={12} md={12} ></Grid>
                <Grid item xs={10} md={10} className={classes.fondotexto}>
                    {
                        (titleone.length > 0) &&
                        <Typography component="h1" variant="h5" align="justify">
                            <b className={classes.texttitleone}>{titleone}</b>
                        </Typography>
                    }
                    {
                        databodyone.map(row => (
                            <div key={row.order}>
                                <Typography component="h1" variant="h5" className={classes.textotitulodetalle} align="justify">
                                    <b className={classes.textotitulodetallenegrita}>{row.title}:</b> {row.value}
                                </Typography>
                                {/* <br /> */}
                            </div>
                        ))
                    }
                    {(tarifas.length > 0) && <br />}
                    {
                        (titletwo.length > 0) &&
                        <Typography component="h1" variant="h5" align="justify">
                            <b className={classes.texttitletwo}>{titletwo}</b>
                        </Typography>
                    }
                    {
                        tarifas.map(row => (
                            <div key={row.tar_id}>
                                <Typography component="h1" variant="h5" className={classes.textotitulodetalle} align="justify">
                                    <b className={classes.textotitulodetallenegrita}>{row.tar_descripcion}:</b> {(row.tar_cant) ? row.tar_cant : (row.cantidad) ? row.cantidad : 0}
                                </Typography>
                                {/* <br /> */}
                            </div>

                        ))
                    }
                    <br />
                    {/* <Grid item xs={12} sm={12}>
                        <Typography component="h1" variant="h5" align="justify">
                            <b className={classes.texttitletwo}>{msg_informative}</b>
                        </Typography>
                    </Grid> */}
                    <Grid item xs={12} md={12} lg={12} xl={12} /* alignItems='center' justifyContent='center' */ >
                        <Typography
                            component="span"
                            variant="body2"
                            style={{ textAlign: 'justify', color: '#1c4c96', fontFamily: 'Roboto-Medium' }}
                        >
                            {msg_informative}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography component="h1" variant="h5" align="justify">
                            <b className={classes.texttitletwo}>Total de pasajeros: {numberOfTickets}</b>
                        </Typography>
                    </Grid>
                </Grid>
                {/* <br /> */}

                {/* <Grid item xs={6} md={6} sm = {6}>
                            <Button
                                fullWidth
                                onClick={ onActionAfter }
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon= {<AddIcon />}
                                className={classes.submit}
                            > { titlebuttonnew }</Button>
                        </Grid> */}

                {(mac === "NAVEGADOR") &&

                    <Grid item xs={6} md={6} sm={6}>
                        <Button

                            fullWidth
                            onClick={handleDownloadVoucher}
                            variant="contained"
                            color="primary"
                            //startIcon = {<CloudDownloadIcon />}
                            className={classes.submit}
                        > Descargar Comprobante</Button>
                    </Grid>
                }
                {(mac !== "NAVEGADOR") &&

                    <Grid item xs={6} md={6} sm={6}>
                        <Button

                            fullWidth
                            onClick={handleDownloadDevice}
                            variant="contained"
                            color="primary"
                            //startIcon = {<CloudDownloadIcon />}
                            className={classes.submit}
                        > Compartir Comprobante</Button>
                    </Grid>
                }

                <Grid item xs={6} md={6} sm={6}>
                    <Button

                        fullWidth
                        onClick={(viewVoucher ? () => history.push('/tranvia') : handleResetPayment)}
                        variant="contained"
                        color="primary"
                        //startIcon = {<CloudDownloadIcon />}
                        className={classes.submit}
                    > Nuevo Pago</Button>
                </Grid>
            </Grid>

        </div>
    );
}



export default TranviaQR;